import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import PlanCard from '../../../front/Plans/Card';
import ServiceButton from './ServiceButton';
import { PLANS } from '../../routing';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(4),
  },
  title: {
    fontWeight: 'bold',
    fontSize: theme.typography.pxToRem(18),
  },
  button: {
    width: 200,
  },
  bottomButtonContainer: {
    marginTop: theme.spacing(4),
    textAlign: 'center',
  },
  buttonButton: {
    width: '100%',
    maxWidth: 400,
  },
}));

const Plans = ({ plans = [], authenticated }) => {
  const classes = useStyles();
  const match = useMediaQuery((theme) => theme.breakpoints.up('sm'));
  const pathNames = window.location.pathname.split('/');
  const query = `?feature=${pathNames[pathNames.length - 1]}`;
  return (
    <>
      {plans.length > 0 && (
        <div className={classes.header}>
          <Typography variant="h3" className={classes.title}>
            この地域のおてつたびを見る
          </Typography>
          {match && (
            <ServiceButton
              classes={{ root: classes.button }}
              href={PLANS + query}
            >
              一覧を見る
            </ServiceButton>
          )}
        </div>
      )}
      <Grid container spacing={2}>
        {plans.map((plan, idx) => (
          <Grid item xs={6} sm={4} md={3} lg={2} key={idx}>
            <PlanCard {...plan} isAuthenticated={authenticated} />
          </Grid>
        ))}
      </Grid>
      {plans.length > 0 && !match && (
        <div className={classes.bottomButtonContainer}>
          <ServiceButton
            classes={{ root: classes.buttonButton }}
            href={PLANS + query}
          >
            一覧を見る
          </ServiceButton>
        </div>
      )}
    </>
  );
};

export default Plans;
